import type { DashboardEventScopeDescription } from "../_utils/dashboardEventScopeLabels";
import { DASHBOARD_PANEL_HEADER_CLASS } from "../_utils/dashboardPanelStyles";

type DashboardEventPanelHeaderProps = {
  title: string;
  scopeDescription?: DashboardEventScopeDescription | null;
  testId?: string;
};

export default function DashboardEventPanelHeader({ title, scopeDescription, testId }: DashboardEventPanelHeaderProps) {
  return (
    <div className={DASHBOARD_PANEL_HEADER_CLASS}>
      <div className="min-w-0">
        <h2 className="!m-0 text-title-medium-bold text-sys-brand-on-surface">{title}</h2>
        {scopeDescription ? (
          <div className="mt-1 text-body-medium text-sys-brand-on-surface-variant" data-testid={testId}>
            {scopeDescription.leadIn}{" "}
            {scopeDescription.tooltip ? (
              <details className="inline">
                <summary className="inline cursor-pointer underline decoration-dotted underline-offset-2 [&::-webkit-details-marker]:hidden">
                  {scopeDescription.sectionLabel}
                </summary>
                : <span>{scopeDescription.tooltip}</span>
              </details>
            ) : (
              <span>{scopeDescription.sectionLabel}</span>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}
